<template>
    <main id="succes-regis--wrapper">
        <div id="succes-regis-page">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url, status: false },
                    { title: 'Register', url: '/community/register', status: true }
                ]"
            ></breadcrumb>
            <div id="succes-register" class="container-fluid title-row ">
                <div class="container">
                    <div class="row justify-content-center py-5">
                        <div class="col-md-4 text-center">
                            <h2>Profile</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container py-5">
                <div class="row text-center justify-content-center">
                    <div class="col-md-4">
                        <img :src="base_url+'/images/check.png'" id="img-check" alt="">
                        <div class="row pt-5">
                            <div class="col">
                                <h3 class="desc-info">Pendaftaran Berhasil</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p class="detail">
                                    Terima kasih sudah mendaftar. Ayo raih poin sebanyak-banyaknya di Honda Community ID
                                </p>
                            </div>
                        </div>
                        <div class="row py-4">
                            <div class="col">
                                <a href="/community/hcid"><span class="btn btn-red">Ke Halaman Profil</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <popup-giveaway></popup-giveaway> -->
    </main>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import PopupGiveaway from "../../widget/PopupGiveaway.vue";
import { sha256, sha224 } from 'js-sha256';

export default {
    components: {
        breadcrumb: BreadCrumb,
        "popup-giveaway": PopupGiveaway
    },
    data() {
        return {
            base_url:'',
            app_url:'',
            api_url:'',
            mobile: false
        };
    },
    created() {
        this.trackerSuccess();
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        this.$scrollTo('#succes-register');
        if(localStorage.getItem('register-success') != null){
            localStorage.removeItem('register-success')
        }else{
            this.$router.push({ path: '/community/hcid'});
        }
    },
    methods: {
        trackerSuccess() {
            // var encrdata = JSON.parse(localStorage.getItem('encrSuccess'));
            const hcid = localStorage.getItem('hcprfhcid');
            const phone = localStorage.getItem('hcprfencphnmbr');
            const email = localStorage.getItem('hcprfenceml')
            const data = {
                'event': 'registerStep9',
                'eventDetail.category': 'Registration',
                'eventDetail.action': 'Registration Profile 5',
                'eventDetail.label': 'Registration Success',
                'userId': hcid,
                'phone': phone,
                'email': email
            }

            // console.log('Register Step 9 = ', data);
            dataLayer.push(data);

            localStorage.removeItem('hcprfhcid')
            localStorage.removeItem('hcprfencphnmbr')
            localStorage.removeItem('hcprfenceml')
        },
    }
};
</script>

<style scoped lang="scss">
#succes-regis-page{
    background: #000000;
    .desc-info{
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
        color: #FFFFFF;
    }
    .detail {
        font-style: normal;
        font-weight: 300;
        font-size: 15px;
        line-height: 24px;
        text-align: center;
        color: #FFFFFF;
    }
    .title-row{
        background: #181818;
        opacity: 0.95;
        font-family: Manrope;
        font-style: normal;
        font-weight: bold;
        font-size: 32px;
        line-height: 42px;
        color: #FFFFFF;
    }
    .info-row{
        background: #1E1E1E;
    }
    #img-info{
        max-height: 25px;
    }
    #img-check{
        max-height: 60px;
    }
    .btn{
        width: 161px;
        height: 50px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    .btn:hover {
        color: white;
        text-decoration: none;
    }
    .btn-white{
        border: 1px solid #DBDBDB;
        box-sizing: border-box;
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        color: #E61B33;
    }
    .btn-red{
        background: #E61B33;
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        color: #FFFFFF;
    }
}
</style>
